import React, { useEffect, useState } from 'react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { Button, Input } from '@/shared/ui'
import { useAdminRoles } from '@/shared/hooks'
import type { AdminRole, AdminUserCreateRequest } from '@/shared/api'

interface Props {
  isOpen: boolean
  loading?: boolean
  onClose: () => void
  onSubmit: (data: AdminUserCreateRequest) => void | Promise<void>
}

const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/

export const CreateEmployeeModal: React.FC<Props> = ({ isOpen, loading, onClose, onSubmit }) => {
  const { data: roles } = useAdminRoles()
  const [login, setLogin] = useState('')
  const [email, setEmail] = useState('')
  const [name, setName] = useState('')
  const [password, setPassword] = useState('')
  const [roleId, setRoleId] = useState('')
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!isOpen) return
    setLogin(''); setEmail(''); setName(''); setPassword(''); setRoleId(''); setError(null)
  }, [isOpen])

  if (!isOpen) return null

  const handleSubmit = () => {
    if (!login.trim() || !email.trim() || !name.trim() || !password) {
      setError('Заполните логин, email, имя и пароль')
      return
    }
    if (!EMAIL_RE.test(email.trim())) {
      setError('Некорректный email')
      return
    }
    if (password.length < 8) {
      setError('Пароль — минимум 8 символов')
      return
    }
    setError(null)
    void onSubmit({
      login: login.trim(),
      email: email.trim(),
      name: name.trim(),
      password,
      admin_role_id: roleId ? Number(roleId) : null,
    })
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-40 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-lg w-full">
        <div className="flex items-center justify-between p-6 border-b">
          <h2 className="text-xl font-semibold text-gray-900">Новый сотрудник</h2>
          <button
            onClick={onClose}
            disabled={loading}
            className="text-gray-400 hover:text-gray-600 disabled:opacity-50"
          >
            <XMarkIcon className="w-6 h-6" />
          </button>
        </div>
        <div className="p-6 space-y-5">
          <Input label="Логин" value={login} onChange={(e) => setLogin(e.target.value)} />
          <Input label="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
          <Input label="Имя" value={name} onChange={(e) => setName(e.target.value)} />
          <Input label="Пароль" type="password" value={password}
                 onChange={(e) => setPassword(e.target.value)} />
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Роль</label>
            <select className="admin-input" value={roleId}
                    onChange={(e) => setRoleId(e.target.value)}>
              <option value="">— без роли —</option>
              {(roles?.items || []).map((role: AdminRole) => (
                <option key={role.admin_role_id} value={role.admin_role_id}>{role.name}</option>
              ))}
            </select>
          </div>
          {error && <div className="text-sm text-red-600">{error}</div>}
        </div>
        <div className="flex justify-end gap-3 p-6 border-t bg-gray-50">
          <Button variant="secondary" onClick={onClose} disabled={loading}>Отмена</Button>
          <Button onClick={handleSubmit} isLoading={!!loading}>Создать</Button>
        </div>
      </div>
    </div>
  )
}
